import * as React from "react";
import styled from "styled-components";
const Container = styled.div(
  ({ $fullHeight }) => `
  display: flex;
  height: ${$fullHeight ? "100%" : "auto"};
  justify-content: center;
  align-items: center;
`
);
const Center = ({ children, fullHeight = true }) => /* @__PURE__ */ React.createElement(Container, { $fullHeight: fullHeight }, children);
export default Center;
